"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalPortal = exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _oxygenConfig = require("@8x8/oxygen-config");

var _oxygenConstants = require("@8x8/oxygen-constants");

var _oxygenOverlay = _interopRequireDefault(require("@8x8/oxygen-overlay"));

var _Modal = require("./Modal.props");

var Styled = _interopRequireWildcard(require("../styled/ModalPortal.styled"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ModalPortal = /*#__PURE__*/function (_Component) {
  _inherits(ModalPortal, _Component);

  var _super = _createSuper(ModalPortal);

  function ModalPortal() {
    var _this;

    _classCallCheck(this, ModalPortal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.onOverlayClick = function () {
      if (_this.props.shouldCloseOnOverlayClick) {
        _this.props.onClose();
      }
    };

    _this.onKeyDown = function (event) {
      if (_this.props.shouldCloseOnEsc && event.keyCode === _oxygenConstants.keyCode.ESCAPE) {
        _this.props.onClose();
      }
    };

    _this.setContentRef = function (ref) {
      if (ref && !_this.props.disableAutoFocus) {
        ref.focus();
      }
    };

    return _this;
  }

  _createClass(ModalPortal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isVisible = _this$props.isVisible,
          hasShadow = _this$props.hasShadow,
          shouldCloseOnEsc = _this$props.shouldCloseOnEsc,
          shouldCloseOnOverlayClick = _this$props.shouldCloseOnOverlayClick,
          size = _this$props.size,
          width = _this$props.width,
          height = _this$props.height,
          onClose = _this$props.onClose,
          children = _this$props.children,
          testId = _this$props.testId,
          theme = _this$props.theme,
          props = _objectWithoutProperties(_this$props, ["isVisible", "hasShadow", "shouldCloseOnEsc", "shouldCloseOnOverlayClick", "size", "width", "height", "onClose", "children", "testId", "theme"]);

      if (!isVisible) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
        theme: theme
      }, /*#__PURE__*/_react["default"].createElement(Styled.Container, props, /*#__PURE__*/_react["default"].createElement(_oxygenOverlay["default"], {
        onClick: this.onOverlayClick,
        onKeyDown: this.onKeyDown,
        tabIndex: "0"
      }), /*#__PURE__*/_react["default"].createElement(Styled.Content, {
        size: size,
        width: width,
        height: height,
        hasShadow: hasShadow,
        ref: this.setContentRef,
        onKeyDown: this.onKeyDown,
        tabIndex: "0",
        testId: testId
      }, children)));
    }
  }]);

  return ModalPortal;
}(_react.Component);

exports.ModalPortal = ModalPortal;
ModalPortal.propTypes = _Modal.propTypes;
ModalPortal.defaultProps = _Modal.defaultProps;

var _default = (0, _oxygenConfig.withTheme)(ModalPortal, 'modal');

exports["default"] = _default;